import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import React, { FC } from 'react';
import { Accordion } from 'react-bootstrap';
import ResignationRetirementDeathHistoryForm from '../forms/resignation-retirement-death-history-form';
import { useDispatch, useSelector } from 'react-redux';
import {
    EducationHistoryModel,
    ResignationRetirementDeathHistoryModel
} from '../../../../shared/models/employee.model';
import { handleEmployeeSectionAddNewData } from '../../../../shared/utils/function-state';
import SectionAddRow from '../section-add-row';
import {
    getCurrentEmployee,
    getCurrentEmployeeEditProfile,
    getEmployeeAction
} from '../../../../shared/services/employee-service';

interface EmployeeResignationRetirementDeathHistoryProps {
    defaultKey?: AccordionEventKey;
}

const EmployeeResignationRetirementDeathHistory: FC<EmployeeResignationRetirementDeathHistoryProps> = ({defaultKey = '0'}) => {
    const dispatch = useDispatch();
    const employee = useSelector(getCurrentEmployee);
    const employeeAction = useSelector(getEmployeeAction);

    const employeeEditProfile = useSelector(getCurrentEmployeeEditProfile);
    const haveSomeEditField = () => {
        if (employeeAction.type === 'view-edit-request') {
            const lengthNotSame = employee.resignation_retirement_death_histories.length !== employeeEditProfile.resignation_retirement_death_histories.length;

            if (lengthNotSame)
                return true;

            return employee.resignation_retirement_death_histories.some((data, index) => {
                return Object.keys(data).some(key => {
                    const kk = key as keyof ResignationRetirementDeathHistoryModel;
                    if (key === 'id' || key === 'employee_id' || key === 'created_at'  || key === 'updated_at' || key === 'from_id')
                        return false;
                    return employeeEditProfile.resignation_retirement_death_histories[index][kk] !== data[kk];
                });
            });
        }
        return false;
    };

    const onAddNewData = () => {
        const initData: ResignationRetirementDeathHistoryModel = {
            id: null,
            employee_id: null,
            date: null,
            status: null,
            order_no: null,
            file: null,
            new_file: true,
            file_name: '',
            from_id: null,
        };
        handleEmployeeSectionAddNewData('resignation_retirement_death_histories', initData, dispatch);
    };

    return (
        <Accordion defaultActiveKey={defaultKey} className="mt-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className={`text-mof-primary ${haveSomeEditField() ? 'accordion-warning' : ''}`}>
                    <h5 className="text-mof-primary m-0">ประวัติการลาออก / เกษียณอายุ / เสียชีวิต</h5>
                </Accordion.Header>
                <Accordion.Body>
                    <ResignationRetirementDeathHistoryForm/>
                    <SectionAddRow onAddNewData={onAddNewData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default EmployeeResignationRetirementDeathHistory;